import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import cargoOfficerListingUserPermissionDefinition from "./cargo-officer-listing-user-permission";

const useCargoOfficerListingUserPermissions = () => {
  return useUserPermissions(cargoOfficerListingUserPermissionDefinition);
};

export default useCargoOfficerListingUserPermissions;
